/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { QuestionnaireStrictHttpResponse } from '../../questionnaire-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AcceptQuestionnaireConsentRequestModel } from '../../models/accept-questionnaire-consent-request-model';
import { QuestionnaireConsentResponseModel } from '../../models/questionnaire-consent-response-model';

export interface ApiConsumerQuestionnaireConsentAcceptPost$Params {
      body?: AcceptQuestionnaireConsentRequestModel
}

export function apiConsumerQuestionnaireConsentAcceptPost(http: HttpClient, rootUrl: string, params?: ApiConsumerQuestionnaireConsentAcceptPost$Params, context?: HttpContext): Observable<QuestionnaireStrictHttpResponse<QuestionnaireConsentResponseModel>> {
  const rb = new RequestBuilder(rootUrl, apiConsumerQuestionnaireConsentAcceptPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as QuestionnaireStrictHttpResponse<QuestionnaireConsentResponseModel>;
    })
  );
}

apiConsumerQuestionnaireConsentAcceptPost.PATH = '/api/consumer/questionnaire/consent/accept';
